export const servicesData = [
  {
    id: 1,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, {
    id: 2,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, {
    id: 3,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, {
    id: 4,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, {
    id: 5,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, {
    id: 5,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  }, {
    id: 5,
    serviceName: 'Crop harvesting',
    price: '50 sq.ft',
    contact: '+921234567',
    area: 'Punjab Region',
    description: 'Lorem ipsum dolor ...'
  },

]

export const myOrderHeadCells = [
  {id: "productName", label: "harvest name"},
  {id: "productLocation", label: "product location"},
  {id: "price", label: "price"},
  {id: "qty", label: "QTY"},
  {id: "date", label: "date"},
  {id: "status", label: "status"},
  // {id: "orderGroupNumber", numeric: false, disablePadding: false, label: "order Group #"},
  // {id: "bidDate", numeric: false, disablePadding: false, label: "bid Date",},
  // {id: "harvestUnitPrice", numeric: true, disablePadding: false, label: "Price"},
  // {id: "shippingAddress", numeric: true, disablePadding: false, label: "shipping Address"},
  {id: "action", numeric: true, disablePadding: false, label: "action"},

];

export const ordersForMeHeadCells = [
  {id: "orderNumber", numeric: false, disablePadding: true, label: "order #"},
  {id: "orderGroupNumber", numeric: false, disablePadding: false, label: "order Group #"},
  {id: "bidDate", numeric: false, disablePadding: false, label: "bid Date",},
  {id: "harvestUnitPrice", numeric: true, disablePadding: false, label: "Price"},
  {id: "action", numeric: true, disablePadding: false, label: "action"},
];
